import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M11.083 15.04a.79.79 0 0 1-.791.791H9.5v2.375a.79.79 0 0 1-.792.792H5.542a.79.79 0 1 1 0-1.581h2.375V15.83H3.958A3.963 3.963 0 0 1 0 11.873V5.539a3.96 3.96 0 0 1 3.958-3.956h4.75a.79.79 0 1 1 0 1.581h-4.75A2.38 2.38 0 0 0 1.583 5.54v6.334a2.38 2.38 0 0 0 2.375 2.377h6.334a.79.79 0 0 1 .791.79M19 2.372v2.375a2.38 2.38 0 0 1-2.375 2.375h-2.258l-1.924 1.43a.79.79 0 0 1-.83.07c-.267-.135-.529-.456-.529-.754l-.002-5.494A2.38 2.38 0 0 1 13.458 0h3.167c.634 0 1.231.245 1.68.694.447.448.695 1.045.695 1.68m-1.583 0a.79.79 0 0 0-.792-.791h-3.167a.794.794 0 0 0-.791.792v4.039l.966-.718a.8.8 0 0 1 .473-.153h2.52a.795.795 0 0 0 .791-.794zm-14.2 9.223a.791.791 0 1 0 1.483.554c.24-.638.896-1.068 1.633-1.068.738 0 1.394.429 1.634 1.068a.792.792 0 0 0 1.482-.554C8.981 10.341 7.73 9.5 6.333 9.5c-1.395 0-2.647.843-3.116 2.097m4.7-4.471a1.583 1.583 0 1 0-3.166 0 1.583 1.583 0 0 0 3.166 0m7.125 7.917c-1.852 0-3.469 1.218-3.932 2.962a.792.792 0 0 0 1.531.407c.28-1.052 1.266-1.786 2.402-1.786 1.135 0 2.12.735 2.4 1.787a.792.792 0 0 0 1.531-.407c-.464-1.744-2.08-2.962-3.93-2.962zm0-.792a2.774 2.774 0 0 1-2.771-2.77 2.774 2.774 0 0 1 2.77-2.772 2.774 2.774 0 0 1 2.771 2.771 2.774 2.774 0 0 1-2.77 2.771m0-1.583a1.189 1.189 0 0 0 0-2.375 1.19 1.19 0 0 0-1.188 1.187 1.19 1.19 0 0 0 1.188 1.188"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h19v19H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }